// test2161
(2161 && 0);
